import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, Link } from 'react-router-dom'
import { Result } from 'antd'

// utils
import { isLoggedIn } from '../../utils/auth'

// layouts
import MainLayout from '../../layouts/MainLayout'

const NotFoundPage = () => {
	const [t] = useTranslation()

	const content = (
		<Result
			status='404'
			title='404'
			subTitle={t(
				'loc:Stránka, ktorú sa pokúšate zobraziť, neexistuje Prosím prejdite späť na hlavnú stránku Ak si myslíte, že je to spôsobené chybou aplikácie, prosím kontaktujte nás'
			)}
			extra={<Link to={t('paths:index') as string}>{t('loc:Hlavná stránka')}</Link>}
		/>
	)

	let result
	if (isLoggedIn()) {
		result = <MainLayout>{content}</MainLayout>
	} else {
		result = <Navigate to={t('paths:index') || ''} />
	}
	return result
}

export default NotFoundPage
